import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    RacerName,
    RunnerCell,
    SelectionWrapper,
    TrapCellRaceBox,
} from 'src/domains/sportsbook/webview/components/racesSlider/greyhoundRacing/cardBodyItem/CardBodyItem.style';
import { WidgetTrap } from 'src/domains/sportsbook/webview/components/nextRaces/raceBoxSelection/WidgetTrap';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface CardBodyItemPropsType {
    selectionId: SelectionId;
    specialEvent?: boolean;
}

export const CardBodyItem = observer('CardBodyItem', ({ selectionId, specialEvent }: CardBodyItemPropsType) => {
    const selection = selectionId.getModel();
    const market = selection?.marketId2.getModel() ?? null;
    const common = useCommon();
    const {
        componentVariants: { raceCardVariant },
    } = ConfigComponents.get(common).unifiedComponentConfig;

    if (selection === null || market === null) {
        return null;
    }

    return (
        <>
            <RunnerCell>
                {specialEvent === true ? (
                    <WidgetTrap selectionId={selectionId} />
                ) : (
                    <TrapCellRaceBox
                        trapNumber={selection.metaDataNumber}
                        selectionId={selection.id2}
                    />
                )}
                <RacerName
                    title={selection.name}
                    variant={raceCardVariant}
                >
                    {selection.name}
                </RacerName>
            </RunnerCell>

            <SelectionWrapper
                borderLeft={true}
                selectionId={selectionId}
                variant={raceCardVariant}
            />
        </>
    );
});
